import styled from 'styled-components';

export const Container = styled.div`
  margin: 24px 0;
`;
